import React, { useEffect, useState } from "react";
import api from "~/services/api";

import CreateEditContent from "./CreateEditContent";
import VisualContent from "./VisualContent";

import { LandPage, Container, Main } from './styles';
import CustomBodyContent from "./CustomBodyContent";
import { Colors } from "~/config/Colors";
import { SLCreateModal, SLEditModal } from "~/pages/Sistema/componentes/SistemaList";
import { useSelector } from "react-redux";

export default function CronogramaProjetos() {
  const [data, setData] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil } = useSelector(state => state.auth);
  const [clientes, setClientes] = useState([]);
  const [analistas, setAnalistas] = useState([]);
  const [idEtapa, setIdEtapa] = useState(6);
  const [tipoVisual, setTipoVisual] = useState("1");
  const [etapas, setEtapas] = useState([]);

  useEffect(() => {
    async function handleRequests() {
      api.get("/signed/empresa/gestorprojeto/cliente/clientes", { params: { ativo: 1 } })
        .then(response => setClientes(response.data));

      api.get("/signed/empresa/gestorprojeto/gerencia/analistas")
        .then(response => setAnalistas(response.data));
    }

    handleRequests();
  }, []);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil]);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            className="container-pj"
            requests={{
              findAll: () =>
                api.get('/signed/empresa/gestorprojeto/projetocronogramas', {
                  params: { ativo: "S" },
                }),
              findOne: thisData =>
                api.get('/signed/empresa/gestorprojeto/projetocronograma/mapeado', {
                  params: { idProjeto: thisData.idProjeto },
                }),
            }}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            topMain={false}
            informationPage={{
              title: "Cronograma dos Projetos",
              subTitle: "Crie e Gerencie os Cronogramas dos Projetos",
              icone: "menu-projetos",
              menu: true,
            }}
            selects={[
              {
                list: clientes,
                value: "id",
                label: "nomeFantasia",
                outLabel: "Todos os Clientes",
                filter: "idCliente",
              },
              {
                list: analistas,
                value: "id",
                label: "nome",
                outLabel: "Todos os Analistas",
                filter: "atividadesAnalista.idAnalista",
              },
            ]}
            inputs={[
              { filter: "titulo", label: "Projeto" },
              { filter: "id", label: "Id" },
              { filter: "cliente.nomeFantasia", label: "Cliente" },
            ]}
          >
            <SLEditModal menu={true} title={"Visualizar Cronograma"} setter={setMountedData}>
              {mountedData && (
                <VisualContent {...{ mountedData }} />
              )}
            </SLEditModal>

            <SLCreateModal menu={true} title="Adicionar Cronograma">
              <CreateEditContent />
            </SLCreateModal>

            <CustomBodyContent {...{ data }} />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
